const Managementservice = () => {
  return (
    <div className="management-services" id="management-service">
      <div className="management-title">MANAGEMENT SERVICES</div>
      <div className="management-section">
        <ul className="management-features">
          <li>Industry-Leading Client Support</li>
          <li>Multiple support channels: Phone, Chat, Email, and In-office</li>
          <li>
            Strategic Board Meeting Readiness: Preparation, Participation, and
            Success
          </li>
          <li>ABM Link</li>
          <li>Online Platform for Invoice Approvals and Payments</li>
        </ul>
        <div className="management-how-different">
          <div className="title">HOW WE'RE DIFFERENT</div>
          <p>
            What sets ABM Property Management apart is our unwavering commitment
            to personalized service and the long-term financial health of the
            communities we manage. We take the time to understand each
            Association’s unique needs and goals, ensuring tailored solutions
            that foster both vibrant communities and financial stability. Our
            proactive, responsive team prioritizes clear communication and
            seamless support, making us a trusted partner that residents and
            Board Members can rely on for consistent care and innovative
            solutions.
          </p>
          <div className="d-flex justify-content-center">
            <ul>
              <li>Excellent, timely service from day one</li>
              <li>
                Ability to use your community’s own preferred vendors instead of
                ours
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Managementservice;
